import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { Box, colors, Stack } from "@mui/material"
import { BiCaretDownSquare, BiCaretUpSquare, BiMenuAltRight, BiSearch } from "react-icons/bi"

import { masterRecordsSlice, useColumnFilter } from "@/slice/masterRecordsSlice"
import { RootState } from "@/store"

export const ColumnFunction = (props: { tableName: string }) => {
	const { tableName } = props

	const dispatch = useDispatch()

	const columnNames = useSelector((state: RootState) => {
		const schema = state.masterSchema.data.find((data) => data.tableName == tableName)
		if (!schema) return []
		return schema.columns.map((c) => c.name)
	})
	const sortColumn = useSelector((state: RootState) => {
		return state.masterRecords.sortColumn[tableName] ?? {}
	})
	const filterColumn = useColumnFilter(tableName)

	const onChangeSort = React.useCallback(
		(columnName: string) => {
			let newSortMode: "asc" | "desc" | undefined = "asc"
			if (sortColumn[columnName]) {
				newSortMode = sortColumn[columnName] == "asc" ? "desc" : undefined
			}
			dispatch(masterRecordsSlice.actions.setSortColumn({ tableName, columnName, mode: newSortMode }))
		},
		[sortColumn, dispatch, tableName],
	)

	const onColumnFilter = React.useCallback(
		(columnName: string) => {
			if (Object.prototype.hasOwnProperty.call(filterColumn, columnName)) {
				dispatch(masterRecordsSlice.actions.resetFilterColumn({ tableName, columnName }))
			} else {
				dispatch(masterRecordsSlice.actions.setFilterColumn({ tableName, columnName, keyword: undefined }))
			}
		},
		[filterColumn, tableName, dispatch],
	)

	const isActiveSearchColumn = (columnName: string): boolean => {
		return Object.prototype.hasOwnProperty.call(filterColumn, columnName)
	}

	return (
		<Box role="row" aria-label="header" display="contents">
			{columnNames.map((columnName, _i) => (
				<Stack direction="row" justifyContent="end" key={columnName}>
					<Box
						sx={{
							cursor: "pointer",
							userSelect: "none",
							color: isActiveSearchColumn(columnName) ? "primary.main" : colors.grey[400],
							paddingRight: "5px",
						}}
						onClick={() => onColumnFilter(columnName)}
					>
						<BiSearch />
					</Box>

					<Box
						sx={{
							cursor: "pointer",
							userSelect: "none",
							color: sortColumn[columnName] ? "primary.main" : colors.grey[400],
							paddingRight: "5px",
						}}
						onClick={() => onChangeSort(columnName)}
					>
						{sortColumn[columnName] == "desc" ? (
							<BiCaretDownSquare />
						) : sortColumn[columnName] == "asc" ? (
							<BiCaretUpSquare />
						) : (
							<BiMenuAltRight />
						)}
					</Box>
				</Stack>
			))}
		</Box>
	)
}
